import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { RemoteFetchMapDistance } from "../../../data/usecases/brick-management/remote-map-distance";
import { FetchMapDistance } from "../../../domain/useages/brick-management/fetch-map-distance";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchMapDistanceInterface {
  FetchMapDistanceState: FetchState;
  fetchMapDistance: Function;
}

const initialStates = {
  FetchMapDistanceState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchMapDistanceSlice: StateCreator<
  FetchMapDistanceInterface
> = (set) => ({
  ...initialStates,
  fetchMapDistance: async (params: FetchMapDistance.Params) => {
  const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
  const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchMapDistance = new RemoteFetchMapDistance(
      `${BASE_URL}${Endpoints.FETCH_MAP_DISTANCE}`,
      axiosHttpClient
    );

    let result = await remoteFetchMapDistance.fetch(params);
    return result;
  },
});
